// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2Oiz0","modal":"Modal_modal__3ixu-","button":"Modal_button__3saQQ","headline":"Modal_headline__hmnk1"};